export default __webpack_public_path__ + "static/media/image_1.3091ea99.jpg";